import { ClipboardList, Home, Search, SquarePen } from "lucide-react";
import { HiOutlineShieldExclamation } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import { routes } from "~/lib/constants";
import { cn } from "~/lib/utils";

export default function MobileFooterTab() {
  const location = useLocation();

  const isActiveRoute = (path: string) => location.pathname.includes(path);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 block border-t border-primary-500 bg-primary-500 shadow-md sm:hidden">
      <div className="flex items-center justify-between gap-2 px-4 py-6">
        <Link
          to={routes.home()}
          className={cn(
            "flex flex-col items-center text-white hover:text-secondary-500",
            {
              "text-secondary-500": isActiveRoute(routes.home()),
            },
          )}
        >
          <Home className="h-8 w-8" />
        </Link>

        <Link
          to={routes.incidents()}
          className={cn(
            "flex flex-col items-center text-white hover:text-secondary-500",
            {
              "text-secondary-500": isActiveRoute(routes.incidents()),
            },
          )}
        >
          <HiOutlineShieldExclamation className="h-8 w-8" />
        </Link>

        <Link
          to={routes.observations()}
          className={cn(
            "flex flex-col items-center text-white hover:text-secondary-500",
            {
              "text-secondary-500": isActiveRoute(routes.observations()),
            },
          )}
        >
          <ClipboardList className="h-8 w-8" />
        </Link>

        <Link
          to={routes.inspections()}
          className={cn(
            "flex flex-col items-center text-white hover:text-secondary-500",
            {
              "text-secondary-500": isActiveRoute(routes.inspections()),
            },
          )}
        >
          <Search className="h-8 w-8" />
        </Link>

        <Link
          to={routes.audits()}
          className={cn(
            "flex flex-col items-center text-white hover:text-secondary-500",
            {
              "text-secondary-500": isActiveRoute(routes.audits()),
            },
          )}
        >
          <SquarePen className="h-8 w-8" />
        </Link>
      </div>
    </div>
  );
}
